export const NAV_ITEMS = [
  { id: "services", key: "services" },
  { id: "about", key: "about" },
  { id: "process", key: "process" },
  { id: "booking", key: "booking" },
  { id: "contact", key: "contact" },
];

export const LANGS = [
  { code: "hu", label: "HU" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "nl", label: "NL" },
];
